import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import avatar from '../assets/images/avatar.jpg';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import styled from 'styled-components'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link as ScrollLink } from "react-scroll";

const NavStyled = styled.nav`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    height: 100%;
    border-right: 1px solid var(--border-color);
    width: 16.3rem;
    position: fixed;
    height: 100vh;
    background-color: var(--Navbar-dark-color);
    overflow: hidden;
    transition: all .4s ease-in-out;
    @media screen and (max-width:1200px){
        transform: translateX(-100%);
        z-index: 20;
    }
    .avatar{
        width: 100%;
        border-bottom: 1px solid var(--border-color);
        text-align: center;
        padding: 1rem 0;
        img{
            width: 70%;
            height: 92%;
            border-radius: 50%;
            border: 4px solid #288ffd;
        }
    }
    .nav-items{
        width: 100%;
        text-align: center;
        .active-nav-item{
            background-color: var(--primary-color-light);
            color: white;
        }       
        li{
            display: block;   //If you comment this it's working fine now
            a{
                display: block;
                padding: .45rem 0;
                position: relative;
                z-index: 10;
                text-transform: uppercase;
                transition: all .4s ease-in-out;
                font-weight: 600;
                letter-spacing: 1px;
                &:hover{
                    cursor: pointer;
                    color: var(--white-color);
                }
                &::before{
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0;
                    height: 50%;
                    background-color: var( --primary-color);
                    transition: All 0.4s cubic-bezier(1,-0.2,.25,.95) ;
                    opacity: 0.21;
                    z-index: -1;
                }
            }
            a:hover::before{
                width: 100%;
                height: 100%;
            }
        }
    }
    footer{
        border-top: 1px solid var(--border-color);
        width: 100%;
        margin-bottom: 1rem;
        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }
            .i-linkedIn{
                &:hover{
                    color: #0077b5;
                }
            }
            .i-github{
                &:hover{
                    color: #790079;
                }
            }
            .i-twitter{
                &:hover{
                    color: #1DA1F2;
                }
            }
            .i-instagram{
                &:hover{
                    color: #bc2a8d;
                }
            }
        }
        @keyframes text{
            0%{
                width: 0ch;
            }
            50%{
                width: 18ch;
            }
        }
    }
`;

const NavLink = styled(ScrollLink)``

const Navbar = ({ navToggle, setNavToggle }) => {
    const { pathname } = useLocation()

    const nav = [
        { to: 'HomePage', title: 'HOME' },
        { to: 'AboutPage', title: 'ABOUT' },
        { to: 'SkillsPage', title: 'SKILLS' },
        { to: 'ProjectsPage', title: 'PROJECTS' },
        { to: 'StatisticsPage', title: 'Statistics' },
        { to: 'ContactPage', title: 'CONTACT' },
    ]

    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    return (
        <NavStyled className={`${navToggle ? 'nav-toggle' : ''}`}>
            <div className="avatar">
                <img src={avatar} alt="avatar" />
            </div>

            <ul className="nav-items">
                {nav.map((item, i) => (
                    <li key={i}>
                        <NavLink key={i + 1} to={item.to} className={`${pathname === item.to ? "active-nav-item" : ""}`} onClick={() => setNavToggle(!navToggle)}
                            spy={true}
                            smooth={true}
                            offset={-100}
                            duration={500}
                        >{item.title}</NavLink>
                    </li>
                ))}
            </ul>

            <footer className="footer">
                <div className="icons">
                    <a href="https://www.linkedin.com/in/ahsanbeg/" target="_blank" rel="noopener noreferrer" className="icon i-linkedIn">
                        <LinkedInIcon />
                    </a>
                    <a href="https://github.com/ahsanofficial" target="_blank" rel="noopener noreferrer" className="icon i-github">
                        <GithubIcon />
                    </a>
                    <a href="https://twitter.com/imAhsanmirza" target="_blank" rel="noopener noreferrer" className="icon i-twitter">
                        <TwitterIcon />
                    </a>
                    <a href="https://instagram.com/ahsan_beg_official/" target="_blank" rel="noopener noreferrer" className="icon i-instagram">
                        <InstagramIcon />
                    </a>
                </div>
            </footer>
        </NavStyled>
    )
}
export default Navbar